import Line from './Line';
import Circle from './Circle';

export { Line, Circle };

export default {
  Line: Line,
  Circle: Circle
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-progress@2.2.6@rc-progress/es/index.js
// module id = 680
// module chunks = 0 1